import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// Icons for event types
import FastfoodIcon from '@mui/icons-material/Fastfood';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import MoodIcon from '@mui/icons-material/Mood';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EventNoteIcon from '@mui/icons-material/EventNote';

import { CalendarEventType } from '@/types/calendar';

interface AddEventMenuProps {
  eventTypes: CalendarEventType[];
  /** Самодостатній режим: повертає повний об'єкт */
  onEventTypeSelect?: (eventType: CalendarEventType) => void;
  /** Контрольований режим (DashboardLayout): повертає лише code */
  onSelectEventType?: (code: string) => void;
  disabled?: boolean;
  // Контрольований режим
  open?: boolean;
  onClose?: () => void;
  loading?: boolean;
  error?: string | null;
}

// Helper function to map event type codes to icons
const getEventTypeIcon = (code: string) => {
  switch (code) {
    case 'food': return <FastfoodIcon fontSize="small" />;
    case 'workout': return <FitnessCenterIcon fontSize="small" />;
    case 'liquid': return <LocalDrinkIcon fontSize="small" />;
    case 'feeling': return <MoodIcon fontSize="small" />;
    case 'medication': return <MedicalServicesIcon fontSize="small" />;
    case 'task': return <AssignmentIcon fontSize="small" />;
    default: return <EventNoteIcon fontSize="small" />;
  }
};

export const AddEventMenuButton: React.FC<AddEventMenuProps> = ({
  eventTypes,
  onEventTypeSelect,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (eventType: CalendarEventType) => {
    if (onEventTypeSelect) {
      onEventTypeSelect(eventType);
    }
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<AddIcon />}
        onClick={handleClick}
        disabled={disabled || eventTypes.length === 0}
        sx={{ ml: 'auto', height: '40px' }}
      >
        Додати подію
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'add-event-button',
        }}
      >
        {eventTypes.map((eventType) => (
          <MenuItem
            key={eventType.id}
            onClick={() => handleMenuItemClick(eventType)}
          >
            <ListItemIcon>
              {getEventTypeIcon(eventType.code)}
            </ListItemIcon>
            <ListItemText>{eventType.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
